import type { Command } from '@sceneio/graphql-subscriptions'
import { useCallback } from 'react'

function asyncResultStateHelper<
  T extends Parameters<Command.CallbackMap['asyncResult']>[0],
>(
  arg: T,
  callbacks: {
    onRequested: (arg: T) => void
    onSuccess: (arg: T) => void
    onFailed: (arg: T) => void
  },
) {
  const { onRequested, onSuccess, onFailed } = callbacks

  if (arg.status === 'requested') return onRequested(arg)
  if (arg.status === 'success') return onSuccess(arg)
  if (arg.status === 'failed') return onFailed(arg)

  console.log(`[asyncResultStateHelper]: Unknown status "${arg.status}"`, arg)
}

export function useCommandCallback() {
  const asyncResultResolver: Command.CallbackMap['asyncResult'] = useCallback(
    (commandArg, timestamp) => {
      // TODO - specify args for content:airprompt
      if (commandArg.type === 'content:aiprompt') {
        return asyncResultStateHelper(commandArg, {
          onRequested(/* arg */) {},
          onFailed(/* arg */) {},
          onSuccess(/* arg */) {},
        })
      }

      // TODO - specify args for content:deploy
      if (commandArg.type === 'content:deploy') {
        return asyncResultStateHelper(commandArg, {
          onRequested(/* arg */) {},
          onFailed(/* arg */) {},
          onSuccess(/* arg */) {},
        })
      }

      // fallback message
      console.log(
        `[useCommandCallback]: Not implemented "asyncResult" command callback: "${commandArg}"`,
        commandArg,
        timestamp,
      )
    },
    [],
  )

  return {
    asyncResultResolver,
  }
}
